import React from "react";

export interface OptionItem {
  value: string;
  label: string;
}

export interface MultiSelectPillsProps {
  options: OptionItem[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
}

export function MultiSelectPills({
  options,
  selectedValues,
  onChange,
  disabled,
}: MultiSelectPillsProps): React.ReactElement {
  const toggleOption = (val: string) => {
    if (selectedValues.includes(val)) {
      onChange(selectedValues.filter((v) => v !== val));
    } else {
      onChange([...selectedValues, val]);
    }
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
      {options.map((opt) => {
        const isSelected = selectedValues.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            data-testid={`multi-pill-${opt.value}`}
            onClick={() => toggleOption(opt.value)}
            disabled={disabled}
            style={{
              padding: "8px 14px",
              borderRadius: "var(--radius-pill)",
              border: "none",
              fontSize: "13px",
              fontWeight: isSelected ? 600 : 500,
              backgroundColor: isSelected ? "var(--color-muted-gold)" : "var(--color-canvas)",
              color: isSelected ? "var(--color-paper)" : "var(--color-slate)",
              cursor: disabled ? "not-allowed" : "pointer",
              transition: "all 0.15s ease",
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
